import React, { Component } from "react";
import { connect } from "react-redux";
import { getLoginHistory, logoutUser } from "../../actions/userLogActions";
import { Col, Form, Row, Table, Button } from "react-bootstrap";
import Pagination from "../subLevel/Pagination";
import moment from "moment";

const LOGIN_HISTORY_TYPES = { USER_HISTORY: 'user-history', LOGS_HISTORY: 'logs-history' };
const ROLES = { 'super-admin': 'Super Admin', 'care-admin': 'Care Admin' };

const initalFilters = {
  fromDate: null,
  toDate: null,
  search: '',
  type: LOGIN_HISTORY_TYPES.USER_HISTORY,
}
class LoginLogs extends Component {
  constructor() {
    super();
    this.state = initalFilters;
    this.handleSearch = this.handleSearch.bind(this);
    this.switchPage = this.switchPage.bind(this);
  }

  onChange = (e) => {
    const { id, value } = e.target;

    if (id === 'type') {
      const updatedFilter = { ...initalFilters, type: value };
      this.setState(updatedFilter);
      this.getData(updatedFilter)
      return;
    }

    this.setState({ [id]: value });
  };

  handleLogout = (email, params) => {
    this.props.logoutUser(email, params);
  };


  switchPage(searchData) {
    this.getData({ ...this.state, ...searchData })

  };

  getData(params) {
    this.props.getLoginHistory(params);
  }

  handleSearch() {
    this.getData(this.state);
  }


  componentDidMount() {
    this.getData({ pageNo: 1, pageSize: 10 });
  }

  render() {

    let usersLogsList = []
    if (this.props?.Logs?.agency?.length > 0) {
      usersLogsList = this.props?.Logs?.agency.map((log) => (
        <tr key={log._id}>
          <td>{log.user_id}</td>
          <td>{log.username}</td>
          <td>{ROLES[log.roles]}</td>
          <td> {log.login_time ? moment(log.login_time).format("DD-MM-YYYY HH:mm:ss") : "MALICIOUS ACTIVITY CHECK THIS !!!"}</td>
          <td>{log.logout_time ? moment(log.logout_time).format("DD-MM-YYYY HH:mm:ss") : "-"}</td>
          <td>{log.active}</td>
          {this.state.type === LOGIN_HISTORY_TYPES.USER_HISTORY && <td>
            <Button size="sm" onClick={() => this.handleLogout(log.email, this.state)}>
              Logout
            </Button>
          </td>}
        </tr>
      ));
    } else {
      usersLogsList = <p> No data found</p>;
    }

    return (
      <div>
        <h1 style={{ padding: "0px 30px", marginTop: "10px" }}>Admin Access Logs</h1>
        <Col style={{ marginLeft: 25 }}>
          <Form.Label>Logs Type</Form.Label>
          <div key={`inline-radio`} >
            <Form.Check
              inline
              name="user_type"
              checked={this.state.type == LOGIN_HISTORY_TYPES.USER_HISTORY}
              onChange={this.onChange}
              value={LOGIN_HISTORY_TYPES.USER_HISTORY}
              label="Users"
              type="radio"
              id="type"
            />
            <Form.Check
              inline
              name="user_type"
              checked={this.state.type == LOGIN_HISTORY_TYPES.LOGS_HISTORY}
              onChange={this.onChange}
              value={LOGIN_HISTORY_TYPES.LOGS_HISTORY}
              label="History"
              type="radio"
              id="type"
            />
          </div>
        </Col>
        <Form className="bg-red">
          <Row>
            <Col>
              <Col>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'end',
                    margin: '10px',
                  }}
                >
                  {this.state.type === LOGIN_HISTORY_TYPES.LOGS_HISTORY &&
                    <>
                      <div style={{ padding: "10px" }}>
                        <label style={{ color: '#666666', margin: 0 }}>From</label>
                        <input
                          type="date"
                          id="fromDate"
                          onChange={this.onChange}
                          value={this.state.fromDate}
                        />
                      </div>
                      <div style={{ padding: "10px" }}>
                        <label style={{ color: '#666666', margin: 0 }}>To</label>
                        <input
                          type="date"
                          id="toDate"
                          onChange={this.onChange}
                          value={this.state.toDate}
                        />

                      </div>
                    </>}
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      width: '340px',
                      margin: '10px',
                    }}
                  >
                    <label>Name / Email / PhoneNumber </label>
                    <input
                      type="text"
                      id="search"
                      onChange={this.onChange}
                      value={this.state.search}
                    />

                  </div>
                  <Button style={{ margin: "12px" }} onClick={this.handleSearch}> Search </Button>
                </div>
              </Col>
            </Col>
          </Row>
        </Form>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>User ID</th>
              <th>Name </th>
              <th>Role</th>
              <th>Logged In</th>
              <th>Logged Out</th>
              <th>Status</th>
              {this.state.type === LOGIN_HISTORY_TYPES.USER_HISTORY && <th>Status</th>}
            </tr>
          </thead>
          <tbody>{usersLogsList}</tbody>
        </Table>
        {this.props?.Logs?.agency?.length > 0 ? (
          <Pagination
            currentPage={this.props.Logs.pageNo}
            lastPage={this.props.Logs.totalPages}
            getInfo={this.switchPage}
          />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  Logs: state.logs.logs,
});

export default connect(mapStateToProps, {
  getLoginHistory,
  logoutUser
})(LoginLogs);
